import React from 'react'
import '../Chat.css'

type ChatWelcomeMessageProps = {
  label: string
  notMeButtonLabel: string
  showButton: boolean
  onNotMe: () => void
}

export const ChatWelcomeMessage: React.FC<ChatWelcomeMessageProps> = ({
  label,
  notMeButtonLabel,
  showButton,
  onNotMe,
}) => (
  <div className="chat-message chat-message--bot chat-welcome" data-testid="chat-welcome">
    <div className="chat-welcome__content">
      <span className="chat-welcome__text">{label}</span>
      {showButton && (
        <button
          className="chat-welcome__button"
          onClick={onNotMe}
          data-testid="chat-welcome-not-me"
        >
          {notMeButtonLabel}
        </button>
      )}
    </div>
  </div>
)
